import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetService {

  constructor() { }

  blobToBase64(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onerror = () => observer.error();
      reader.onabort = () => observer.error();
      reader.onload = () => {observer.next(reader.result as string); observer.complete();};

      return () => reader.abort();
    })
  }

}
